// extracted by mini-css-extract-plugin
export default {"button":"hoverbutton_button__xOJd4","text":"hoverbutton_text__CAtO1","icon":"hoverbutton_icon__DsEKi"};